var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframe",staticClass:"text-replace-iframe",attrs:{"src":_vm.textReplaceUrl,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }